<template>
    <div class="auth-page-wrapper pt-5">
        <!-- auth page bg -->
        <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
            <div class="bg-overlay"></div>

            <div class="shape">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                     viewBox="0 0 1440 120">
                    <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8
            1440,40L1440 140L0 140z"></path>
                </svg>
            </div>
        </div>

        <!-- auth page content -->
        <div class="auth-page-content">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center mt-sm-5 mb-4 text-white-50">
                            <div>
                                <router-link to="/" class="d-inline-block auth-logo">
                                    <img :src="asset('/images/logo-white.png')" style="max-width: 20%" alt=""/>
                                </router-link>
                            </div>
                            <!--                            <p class="mt-3 fs-15 fw-medium">-->
                            <!--                                Premium Admin & Dashboard Template-->
                            <!--                            </p>-->
                        </div>
                    </div>
                </div>
                <!-- end row -->

                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-5">
                        <div class="card mt-4">
                            <div class="card-body p-4">
                                <div class="text-center mt-2">
                                    <h5 class="text-primary">Welcome Back !</h5>
                                    <p class="text-muted">Sign in to continue.</p>
                                </div>
                                <div class="p-2 mt-4">
                                    <!--                                    <b-alert v-model="authError" variant="danger" class="mt-3" dismissible>{{-->
                                    <!--                                            authError-->
                                    <!--                                        }}-->
                                    <!--                                    </b-alert>-->
                                    <form @submit.prevent="login()">
                                        <label class="form-label" for="username-input">Username</label>
                                        <div class="position-relative auth-pass-inputgroup mb-3">
                                            <input v-model="form.username" class="form-control pe-5"
                                                   placeholder="Enter Username"
                                                   id="username-input"/>
                                            <div class="invalid-feedback">
                                                <span></span>
                                            </div>
                                        </div>

                                        <div class="mb-3">
                                            <!--                                            <div class="float-end">-->
                                            <!--                                                <router-link to="/forgot-password" class="text-muted">Forgot-->
                                            <!--                                                    password?-->
                                            <!--                                                </router-link>-->
                                            <!--                                            </div>-->
                                            <label class="form-label" for="password-input">Password</label>
                                            <div class="position-relative auth-pass-inputgroup mb-3">
                                                <input :type="passwordFieldType" v-model="form.password" class="form-control pe-5"
                                                       placeholder="Enter password"
                                                       id="password-input"/>
                                                <button @click.prevent="switchVisibility"
                                                        class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                                        type="button" id="password-addon">
                                                    <i class="ri-eye-fill align-middle"></i>
                                                </button>
                                                <div class="invalid-feedback">
                                                    <span></span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value=""
                                                   id="auth-remember-check"/>
                                            <label class="form-check-label" for="auth-remember-check">Remember
                                                me</label>
                                        </div>

                                        <div class="mt-4">
                                            <button class="btn btn-success w-100" type="submit">
                                                Sign In
                                            </button>
                                        </div>

                                        <!--                                        <div class="mt-4 text-center">-->
                                        <!--                                            <div class="signin-other-title">-->
                                        <!--                                                <h5 class="fs-13 mb-4 title">Sign In with</h5>-->
                                        <!--                                            </div>-->
                                        <!--                                            <div>-->
                                        <!--                                                <button type="button"-->
                                        <!--                                                        class="btn btn-primary btn-icon waves-effect waves-light">-->
                                        <!--                                                    <i class="ri-facebook-fill fs-16"></i>-->
                                        <!--                                                </button>-->
                                        <!--                                                <button type="button"-->
                                        <!--                                                        class="btn btn-danger btn-icon waves-effect waves-light ms-1">-->
                                        <!--                                                    <i class="ri-google-fill fs-16"></i>-->
                                        <!--                                                </button>-->
                                        <!--                                                <button type="button"-->
                                        <!--                                                        class="btn btn-dark btn-icon waves-effect waves-light ms-1">-->
                                        <!--                                                    <i class="ri-github-fill fs-16"></i>-->
                                        <!--                                                </button>-->
                                        <!--                                                <button type="button"-->
                                        <!--                                                        class="btn btn-info btn-icon waves-effect waves-light ms-1">-->
                                        <!--                                                    <i class="ri-twitter-fill fs-16"></i>-->
                                        <!--                                                </button>-->
                                        <!--                                            </div>-->
                                        <!--                                        </div>-->
                                    </form>
                                </div>
                            </div>
                            <!-- end card body -->
                        </div>
                        <!-- end card -->

                        <!--                        <div class="mt-4 text-center">-->
                        <!--                            <p class="mb-0">-->
                        <!--                                Don't have an account ?-->
                        <!--                                <router-link to="/register" class="fw-semibold text-primary text-decoration-underline">-->
                        <!--                                    Signup-->
                        <!--                                </router-link>-->
                        <!--                            </p>-->
                        <!--                        </div>-->
                    </div>
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
        </div>
        <!-- end auth page content -->

        <!-- footer -->
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center mb-3">
                            <p class="mb-0 text-muted">&copy; {{ new Date().getFullYear() }} DEKMAK</p>
                            <p class="mb-0 text-muted">Powered By Untitled Developers</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- end Footer -->
    </div>
    <!-- end auth-page-wrapper -->
</template>


<script>
import {defineComponent, onMounted} from 'vue'
import cash from "cash-dom/dist/cash"
import Swal from "sweetalert2";
import useVuelidate from '@vuelidate/core'
import {required} from '@vuelidate/validators'
import {asset} from "@codinglabs/laravel-asset";
import axios from "axios";

export default defineComponent({
    components: {},
    mixins: [{
        methods: {
            asset: asset,
            castTimestamps(obj) {
                let date = new Date(obj.created_at);
                obj.created_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;

                date = new Date(obj.updated_at);
                obj.updated_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;
            },
            switchVisibility() {
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
            },
        }
    }],
    data() {
        return {
            passwordFieldType: 'password',
            form: {
                username: null,
                password: null
            }
        }
    },
    validations() {
        return {
            form: {
                username: {
                    required
                },
                password: {
                    required
                }
            }
        }
    },
    methods: {
        login: function () {
            console.log('logging in');
            axios.post('/api/login', {
                username: this.form.username,
                password: this.form.password
            })
                .then(response => {
                    console.log(response.data);
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        showConfirmButton: false,
                        timer: 1500
                    }).then(result => {
                        window.location.replace("/");
                    });
                })
                .catch(error => {
                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: "Oops...",
                        text: "Invalid Data"
                    });
                });
        }
    },
    setup() {
        onMounted(() => {
            cash('body')
                .removeClass('main')
                .removeClass('error-page')
                .addClass('login')
        })
        return {v$: useVuelidate()}
    }
})
</script>
